import { getEnvPath, findOutWhichEnv } from '../../utils/env'
import { getHeaders, handleErrors } from './utils'

const env = findOutWhichEnv()
const BASE_PATH = `${getEnvPath(env)}/1.0/api`

function getTokenInfo({ authCode, state }) {
  return fetch(`${BASE_PATH}/tiktok/tokeninfo?auth_code=${authCode}&state=${state}`, getHeaders('GET'))
    .then((res) => res.json())
    .then(handleErrors)
}

function getTikTokAccounts() {
  return fetch(`${BASE_PATH}/tiktok/getaccounts`, getHeaders('GET'))
    .then((res) => res.json())
    .then(handleErrors)
}

function revokeAccountConnection(advertiserId) {
  return fetch(`${BASE_PATH}/tiktok/revoke?AdvertiserId=${advertiserId}`, getHeaders('POST'))
}

async function saveToken({ accessToken, advertiserId, advertiserName, eventSetId, eventSetName, tenantId }) {
  return fetch(
    `${BASE_PATH}/tiktok/savetoken`,
    getHeaders('POST', {
      acessToken: accessToken,
      advertiserId,
      advertiserName,
      eventSetId,
      eventSetName,
      tenantId,
    }),
  )
}

async function createEventSet({ name, accessToken, advertiserId }) {
  return fetch(
    `${BASE_PATH}/tiktok/neweventset?acess_token=${accessToken}&event_set_name=${name}&advertiser_id=${advertiserId}`,
    getHeaders('POST'),
  )
    .then((res) => res.json())
    .then(handleErrors)
}

export { getTokenInfo, getTikTokAccounts, revokeAccountConnection, saveToken, createEventSet }
